import PageInfo from "./PageInfo";
import PageCategory from "./PageCategory";
import PageQuestion from "./PageQuestion";
import "../styles/components/quest-step.scss";
import "../styles/components/sticker-logo.scss";

const QuestPage = ({ page, active, setResponse }) => {
  const base_url = process.env.PUBLIC_URL;

  return (
    <div className={`quest-step ${active ? "show" : ""}`}>
      {page.image && (
        <div className="image-wrapper">
          <img  src={`${base_url}/img/${page.image}`} alt="Logo" />
        </div>
      )}

      <div className="step-content">
        {page.type === "info" && <PageInfo page={page} />}

        {page.type === "category" && <PageCategory page={page} />}

        {page.type === "question" && <PageQuestion page={page} setResponse={setResponse} />}
      </div>
    </div>
  );
};

export default QuestPage;
